import axios from "axios";

// const NOTIFICATION_BASE_URL = "http://localhost:2027";
const NOTIFICATION_BASE_URL = "https://notify.vyakhyan.com/api"
const PROJECT_CODE = "swa";

/**
 * Calls the notification trigger API.
 * @param {string} to          - Recipient email address
 * @param {string} templateName - e.g. "Create Account", "Assign Project", "Assign Role", "Assign Module"
 * @param {string} eventCode   - e.g. "Login", "AssignProject", etc.
 * @param {object} payloadData - Key-value pairs matching the template variables
 */
const triggerNotification = async (to, templateName, eventCode, payloadData = {}) => {
    try {
        const body = {
            projectCode: PROJECT_CODE,
            templateName,
            eventCode,
            channels: ["EMAIL"],
            to,
            payload: payloadData,
        };

        console.log("[NotificationService] Triggering notification:", { to, templateName, eventCode, payloadData });

        const res = await axios.post(`${NOTIFICATION_BASE_URL}/notification/trigger`, body);

        console.log("[NotificationService] Notification sent successfully:", res.data);
        return res.data;
    } catch (err) {
        // Never block the main flow — just log
        console.warn("[NotificationService] Notification failed (non-blocking):", err.response?.data || err.message);
        return null;
    }
};

const NotificationService = {
    /**
     * Sends a welcome email after a new user account is created.
     * @param {string} email
     * @param {string} username
     * @param {string} organizationName
     */
    sendCreateAccountNotification(email, username, organizationName = "") {
        return triggerNotification(email, "Create Account", "Login", {
            organizationName,
            userName: username,
        });
    },

    /**
     * Sends a notification when project(s) are assigned to a user.
     * @param {string} email
     * @param {string} username
     * @param {string[]} projectNames  - Array of project names assigned
     * @param {string} organizationName
     */
    sendAssignProjectNotification(email, username, projectNames = [], organizationName = "") {
        return triggerNotification(email, "ProAss", "Project Ass", {
            organizationName,
            userName: username,
            projectNames: Array.isArray(projectNames) ? projectNames : [projectNames],
        });
    },

    /**
     * Sends a notification when a role is assigned to a user.
     * @param {string} email
     * @param {string} username
     * @param {string} roleName
     * @param {string} organizationName
     */
    sendAssignRoleNotification(email, username, roleName = "", organizationName = "") {
        return triggerNotification(email, "Assign Role", "AssignRole", {
            organizationName,
            userName: username,
            roleName,
        });
    },

    /**
     * Sends a notification when a module is assigned to a user.
     * @param {string} email
     * @param {string} username
     * @param {string} moduleName
     * @param {string} organizationName
     */
    sendAssignModuleNotification(email, username, moduleName = "", organizationName = "") {
        return triggerNotification(email, "Assign Module", "AssignModule", {
            organizationName,
            userName: username,
            moduleName,
        });
    },

    /**
     * Sends a notification when a new module is assigned to a user (module creation flow).
     * Uses the "Module Assing" template.
     * @param {string} email            - Recipient email
     * @param {string} userName         - Recipient's display name
     * @param {string} organizationName - Organization the module belongs to
     * @param {string} moduleName       - Name of the newly assigned module
     * @param {string} assignedBy       - Name of the person who created/assigned the module
     * @param {string} assignedDate     - ISO date string of assignment (e.g. new Date().toISOString())
     */
    sendNewModuleAssignNotification(email, userName, organizationName, moduleName, assignedBy, assignedDate) {
        return triggerNotification(email, "Module Assing", "Module assing", {
            userName,
            organizationName,
            moduleName,
            assignedBy,
            assignedDate,
        });
    },
};

export default NotificationService;
